/**
 * Created by kellermaca on 8/08/17.
 */
import router from '../../router'

export default
{
  redirect (state, payload) {
    if (payload) {
      state.is_authenticated = true
      window.localStorage.setItem('token', payload)
      router.push('/')
    }
  },
  redirectlogout (state) {
    state.is_authenticated = false
    localStorage.removeItem('token')
    state.producto = {}
    state.banco = {}
    state.banco2 = {}
    state.banco3 = {}
    state.lineas = []
    state.has_factura = []
    state.factura = {usuario: { username: '' }, credito: false, id: 1}
    state.compras = []
    state.cliente = {nit: ''}
    state.clientecotizacion = {nombre: ''}
    state.is_authenticated = false
    state.error_authenticate = false
    state.error_cliente = false
    state.has_factura = false
    state.vender_bodega = false
    localStorage.removeItem('puede_vender_bodega')
    router.push('/login')
  },
  error_login (state) {
    state.error_authenticate = true
  },
  acturalizarfacturas (state, payload) {
    state.facturas.push(payload)
  },
  actualizarcliente (state, payload) {
    let dato = Object.assign({}, state.cliente, payload)
    state.cliente = dato
  },
  actualizarclientecotizacion (state, payload) {
    let dato = Object.assign({}, state.clientecotizacion, payload)
    state.clientecotizacion = dato
  },
  actualizarfactura (state, payload) {
    let dato = Object.assign({}, state.factura, payload)
    state.factura = dato
  },
  actualizarcompras (state, payload) {
    state.compras = payload
  },
  actualizarmessageactual (state, payload) {
    state.messageactual = payload
  },
  actualizarkilometraje (state, payload) {
    state.kilometrajes = payload
  },
  actualizarkilometrajevendedor (state, payload) {
    state.kilometrajesvendedor = payload
  },
  agregarkilometraje (state, payload) {
    state.kilometrajes.results.push(payload)
  },
  actualizarkilometrajevendedoretit (state, payload) {
    let datos = []
    state.kilometrajesvendedor.results.find(dato => {
      if (dato.id === payload.id) {
        datos.push(payload)
      } else {
        datos.push(dato)
      }
    })
  },
  agregarkilometrajevendedor (state, payload) {
    state.kilometrajesvendedor.results.push(payload)
  },
  setidsfactura (state, payload) {
    state.idsfacturas = payload
  },
  error_searchcliente (state, error) {
    state.error_cliente = error
  },
  actualizarestadofactura (state, payload) {
    state.has_factura = payload
  },
  actualizarestadocotizacion (state, payload) {
    state.has_cotizacion = payload
  },
  actualizarproducto (state, payload) {
    state.producto = payload
  },
  limpiarbarra (state, payload) {
    state.producto.barra = payload
  },
  actualizarbarra (state, payload) {
    state.producto.barra = payload
  },
  updateselect (state, payload) {
    state.listado = payload
  },
  actualizarlinea (state, payload) {
    state.lineas.push(payload)
  },
  limpiarlinea (state) {
    state.lineas = []
  },
  actualizarlineacotizacion (state, payload) {
    state.lineascotizacion.push(payload)
  },
  limpiarlineacotizacion (state) {
    state.lineascotizacion = []
  },
  actualizarpresentaciones (state, payload) {
    if (payload.length === 0) {
      state.presentaciones = []
    } else { state.presentaciones.push(payload) }
  },
  actualizarpresentacion (state, payload) {
    state.presentacion = payload
  },
  eliminarlinea (state, payload) {
    let index = state.lineas.indexOf(payload)
    state.lineas.splice(index, 1)
  },
  eliminarlineacotizacion (state, payload) {
    let index = state.lineascotizacion.indexOf(payload)
    state.lineascotizacion.splice(index, 1)
  },
  actualizardialog (state, payload) {
    console.log(payload)
    state.dialog = payload
  },
  actualizarerror (state, payload) {
    state.error = payload
  },
  actualizarmessage_error (state, payload) {
    state.messageerror = payload
  },
  actualizar_success (state, payload) {
    state.success = payload
  },
  actualizarmessage_success (state, payload) {
    state.messagesuccess = payload
  },
  setdevoluciones (state, payload) {
    state.devoluciones = payload
  },
  resetfactura (state) {
    state.dialog = false
    state.factura = {usuario: { username: '' }, credito: false, id: 1}
    state.productos = []
    state.has_factura = false
    state.cliente = {nit: ''}
    state.messageerror = ''
    state.messagesuccess = ''
    state.lineas = []
    state.error = false
  },
  resetcotizacion (state) {
    state.dialog = false
    state.clientecotizacion = {cliente: ''}
    state.productos = []
    state.has_cotizacion = false
    state.lineascotizacion = []
    state.error = false
  },
  actualizarlistadofacturas (state, payload) {
    state.facturas = payload
  },
  actualizarlistadocotizaciones (state, payload) {
    state.cotizaciones = payload
  },
  eliminarfactura (state, payload) {
    let index = state.facturas.results.indexOf(payload)
    state.facturas.results.splice(index, 1)
  },
  eliminardevolucion (state, payload) {
    let index = state.devoluciones.productos.indexOf(payload)
    state.devoluciones.productos.splice(index, 1)
  },
  agregardevolucion (state, payload) {
    state.devoluciones.productos.push(payload)
  },
  setLineaNota (state, payload) {
    state.lineanota = payload
  },
  eliminarcompra (state, payload) {
    let index = state.compras.results.indexOf(payload)
    state.compras.results.splice(index, 1)
  },
  eliminarcotizacion (state, payload) {
    let index = state.cotizaciones.results.indexOf(payload)
    state.cotizaciones.results.splice(index, 1)
  },
  eliminarextraccion (state, payload) {
    let index = state.extracciones.indexOf(payload)
    state.extracciones.splice(index, 1)
  },
  eliminarkilometraje (state, payload) {
    let index = state.kilometrajes.results.indexOf(payload)
    state.kilometrajes.results.splice(index, 1)
  },
  setguardando (state, payload) {
    state.guardando = payload
  },
  eliminarkilometrajevendedor (state, payload) {
    let index = state.kilometrajesvendedor.results.indexOf(payload)
    state.kilometrajesvendedor.results.splice(index, 1)
  },
  actualizarclientes (state, payload) {
    state.clientes = payload
    let ordenados = state.clientes.results.sort((dato1, dato2) => {
      return dato1.orden - dato2.orden
    })
    state.clientes.results = ordenados
  },
  eliminarcliente (state, payload) {
    let index = state.clientes.results.indexOf(payload)
    state.clientes.results.splice(index, 1)
  },
  limpiarcliente (state) {
    state.cliente = {nit: ''}
  },
  actualizarclientesedit (state, payload) {
    let datos = []
    state.clientes.results.find(dato => {
      if (dato.id === payload.id) {
        datos.push(payload)
      } else { datos.push(dato) }
    })
    let ordenado = datos.sort((dato1, dato2) => {
      return dato1.orden - dato2.orden
    })
    state.clientes.results = ordenado
  },
  actualizarrutas (state, payload) {
    state.rutas = payload
  },
  actualizarbancos (state, payload) {
    state.bancos = payload
  },
  actualizarusuarios (state, payload) {
    state.usuarios = payload
  },
  actualizarproveedores (state, payload) {
    state.proveedores = payload
  },
  actualizarvehiculos (state, payload) {
    state.vehiculos = payload
  },
  actualizarvehiculo (state, payload) {
    state.vehiculo = payload
  },
  actualizarproductos (state, payload) {
    state.productos = payload
  },
  actualizardia: function (state, payload) {
    state.dia = payload
  },
  actualizarruta: function (state, payload) {
    state.ruta = payload
  },
  actualizarusuario: function (state, payload) {
    state.usuario = payload
  },
  actualizarbanco: function (state, payload) {
    state.banco = payload
  },
  actualizarbanco2: function (state, payload) {
    state.banco2 = payload
  },
  actualizardesde: function (state, payload) {
    state.desde = payload
  },
  actualizarhasta: function (state, payload) {
    state.hasta = payload
  },
  actualizarsemana: function (state, payload) {
    state.semana = payload
  },
  actualizartipo: function (state, payload) {
    state.tipo = payload
  },
  actualizarakilometraje: function (state, payload) {
    state.akilometraje = payload
  },
  actualizarakilometrajevendedor: function (state, payload) {
    state.akilometrajevendedor = payload
  },
  actualizarbodega: function (state, payload) {
    state.vender_bodega = payload
  },
  setextracciones: function (state, payload) {
    state.extracciones = payload
  },
  settipoextracciones: function (state, payload) {
    state.tiposextracciones = payload
  },
  setactivadorcliente: function (state, payload) {
    state.tiposextracciones = payload
  },
  setcaja: function (state, payload) {
    state.caja = payload
  },
  setcompra: function (state, payload) {
    state.compra = payload
  },
  seteditcompra: function (state, payload) {
    state.editcompra = payload
  },
  setcompralinea: function (state, payload) {
    state.lineacompra.compra = payload
  },
  setPagada: function (state, payload) {
    state.compra.pagada = payload
  },
  setcredito: function (state, payload) {
    state.compra.credito = payload
  },
  setSerie: function (state, payload) {
    state.compra.serie = payload
  },
  setPresentaciones: function (state, payload) {
    state.listadopresentacion = payload
  },
  eliminarlineacompra: function (state, payload) {
    let index = state.compra.detallescompratemporal.indexOf(payload)
    console.log(index)
    state.compra.detallescompratemporal.splice(index, 1)
  },
  setaddlineacompra: function (state, payload) {
    state.compra.detallescompratemporal.push(payload)
  },
  limpiarlineacompra: function (state, payload) {
    state.lineacompra = payload
  },
  setpreciocompra: function (state, payload) {
    state.lineacompra.precio_compra = payload.precio_compra
    state.lineacompra.precio = payload.precio_compra
    state.lineacompra.presentacion = 7
  },
  aumentartotalc: function (state, payload) {
    console.log(payload)
    state.compra.totalc = state.compra.totalc + (payload.cantidad * payload.precio)
  },
  disminuirtotalc: function (state, payload) {
    console.log(payload)
    state.compra.totalc = state.compra.totalc - (payload.cantidad * payload.precio)
  },
  setEliminando: function (state, payload) {
    state.eliminando = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/mutations.js